@if (isVisible) {
  <button
    class="buttonDs__cont buttonDs__cont--{{type}}"
    aria-label="buttonDs"
    [class.emit]="emitWhenDisabled"
    [class.disabled]="isDisabled"
    [class.button-basket]="isBasket"
    [class.loading]="isLoading"
    [ngStyle]="{
      height: buttonConfig?.Height,
      borderRadius: isSquareSize ? 'var(--border-radius-nano)' : borderRadius,
      width: realButtonWidth
    }"
    (click)="clickTrigger()">
    @if (!isLoading) {
      @if (showIcon) {
        <app-ds-icon
          class="buttonDs__icon buttonDs__icon--{{size}}"
          [icon]="icon"
          [size]="buttonConfig?.IconSize">
        </app-ds-icon>
      }
      @if (!isSquareSize) {
        <app-ds-typography
          [fontFamily]="buttonConfig?.FontFamily"
          [size]="buttonConfig?.FontSize"
          [text]="labels?.ButtonLabel">
        </app-ds-typography>
        @if (isBasket) {
          <app-ds-typography
            [fontFamily]="buttonConfig?.FontFamily"
            [size]="buttonConfig?.FontSize"
            [text]="labels?.BasketLabel">
          </app-ds-typography>
        }
      }
    } @else {
      <app-ds-loader-ring
        [size]="buttonConfig?.LoaderSize"
        [type]="loaderRingType">
      </app-ds-loader-ring>
    }
  </button>
}
